<template>
  <div id="app_WaterDepartmentPortal">
    <page-head :visited="visited" @getVisited="getVisited" />
    <router-view @getVisited="getVisited"></router-view>
    <page-foot :content="companyInfo" />
  </div>
</template>
<script>
import pageHead from './components/page_head'
import pageFoot from './components/page_foot'
import VueRouter from 'vue-router'
import BaiduMap from 'vue-baidu-map'
import companyInfo from './config.js'
import Vue from 'vue'
Vue.use(VueRouter)
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'm3g9GSIBVWFfrlWoDQBgRUTU7veiV47S'
})
import routes from './routes_business'
const router = new VueRouter({
  routes, // (缩写) 相当于 routes: routes
})

export default {
  name: 'app_WaterDepartmentPortal',
  router,
  data() {
    return {
      companyInfo,
      logo: 'img/logo.png',
      visited: 0,
      
      foot: {
        links: [
        ]
      },
    }
  },
  methods: {
    getVisited(visited) {
      this.visited = visited
      console.log(this.visited)
    },
  },
  components: {
    pageHead,
    pageFoot,
  },
  mounted() {
    console.log('检查路由', this.$router)

  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
